import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdDone } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './ConfirmAccountConfirmationCardStyles';
import {
    Button,
    Container
} from '@mui/material';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
}

const ConfirmAccountConfirmationCard: React.FC<Props> = props => {

    const styles = useStyles()
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = '/home';
        history.replace(path);
    }

    return (
        <AuthPage
            title="Your account has been confirmed and is now active!"
            icon={<MdDone />}
            iconTone="ok"
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Go To Log In</button>}>
            <p>Please click on the button below to log in before registering for the auction you wish to partake in.</p>
            <p><strong>Happy Bidding!</strong></p>
        </AuthPage>
    )

}


const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(ConfirmAccountConfirmationCard);